import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { Params, Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { zip } from 'rxjs';
import { TripDetail } from 'src/app/api/commonInterfaces';
import { FormManagementService } from 'src/app/api/form-management.service';
import { FormResponseService } from 'src/app/api/form-response.service';
import { FormResponse, PpmForm } from 'src/app/api/types/forms';
import { TableRowDirective } from 'src/app/ui/utility/table-row.directive';



interface TableViewModel extends FormResponse, Omit<PpmForm, "id"> {
  location: string,
  trips: TripDetail[]
}

@Component({
  selector: 'app-my-requested-responses',
  imports: [TableModule,TableRowDirective, DatePipe],
  templateUrl: './my-requested-responses.component.html',
  styleUrl: './my-requested-responses.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyRequestedResponsesComponent implements OnInit {


  responses = signal<Array<TableViewModel>>([])
  initialized = signal(false)

  constructor(
    private formResponseService: FormResponseService,
    private formManagementService: FormManagementService,
    private router: Router
  ) {

  }
  ngOnInit(): void {
    
    zip(
      this.formManagementService.getAllForms(),
      this.formResponseService.getMyUnsubmittedResponses()
    )
    .subscribe(([forms, responseResult]) => {

      this.responses.set(
        responseResult.responses.map(r => {
          const {id, ...form} = (forms.find(f => f.id === r.formId) ?? this.formManagementService.getEmptyForm())
          return {
            ...r,
            ...form,
            location: responseResult.trips.find(t => r.responseTrips && t.id === r.responseTrips[0]?.tripId)?.location ?? "",
            trips: responseResult.trips.filter( t => r.responseTrips?.map(rt => rt.tripId).includes(t.id))
          }
        })
       
      )

      this.initialized.set(true)
    })
  }
  
  rowClick(response: FormResponse & Omit<PpmForm, "id">) {
    const params: Params = {
      responseId: response.id
    }
      this.router.navigate(['forms', 'response'], {queryParams: params  })
  }
}
